import { Component, OnInit } from '@angular/core';
import { ASSET_PATHS } from '@constants/assets-paths';
import { formatSingleDate, generateLast12Months } from '@utils/utils';
import {
  AssetManagementService,
  CardType,
} from '@pages/asset-management/asset-management-service';
import {
  UPCOMING_ONBOARDING_CARD_COLUMNS as UPCOMING_COLUMNS_DEF,
  UPCOMING_TABLE_CONFIG,
} from '@pages/asset-management/asset-management-table-configuration';
import { TableConfig } from '@shared/components/table/table.interfaces';
import { ActivatedRoute, Router } from '@angular/router';
import { DateUtils } from '@utils/date.utils';
import { yearDateFormat } from '@constants/dateFormat';
import { OnboardingRequest } from '@pages/asset-management/asset-management-table/onboarding-requests-table.service';
import { GlobalErrorService } from '@services/global-error.service';

@Component({
  selector: 'app-upcoming-onboarding-card',
  templateUrl: './upcoming-onboarding-card.component.html',
  styleUrl: './upcoming-onboarding-card.component.scss',
})
export class UpcomingOnboardingCardComponent implements OnInit {
  isLoading: boolean = false;
  selectedMonthValue: string = `${new Date().getMonth() + 1}-${new Date().getFullYear()}`;
  imageSrc: string = 'assets/img/no-data-found.png';
  errorMsg: string = 'No data available';
  public readonly UPCOMING_COLUMNS = UPCOMING_COLUMNS_DEF;
  tableConfig: TableConfig = UPCOMING_TABLE_CONFIG;
  gridOptions: any = {
    context: {
      componentParent: this,
    },
  };
  personCheckIcon = ASSET_PATHS.personCheckIcon;
  onboardingData: OnboardingRequest[] = [];
  selectedMonthLabel: string | null = null;
  maxTableHeight: string = '300px';
  monthOptions = generateLast12Months();
  monthSelected: string = '';
  yearSelected: string = '';

  constructor(
    private readonly assetMgmtService: AssetManagementService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly errorHandler: GlobalErrorService,
  ) {}

  ngOnInit() {
    // Set selectedMonthValue to current month-year string
    this.selectedMonthValue = `${new Date().getMonth() + 1}-${new Date().getFullYear()}`;
    const currentDate = new Date();
    const startOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1,
    );
    const endOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );
    this.monthSelected = DateUtils.getMonthName(currentDate.getMonth());
    this.yearSelected = currentDate.getFullYear().toString();
    this.loadOnboardingData(
      formatSingleDate(startOfMonth, yearDateFormat.date),
      formatSingleDate(endOfMonth, yearDateFormat.date),
    );

    this.selectedMonthLabel = `${this.monthSelected} ${this.yearSelected}`;
  }

  loadOnboardingData(startDate: string, endDate: string): void {
    this.isLoading = true;
    this.assetMgmtService.getOnboardingData(startDate, endDate).subscribe({
      next: (response) => {
        this.onboardingData = response?.data;
        this.isLoading = false;
      },
      error: (error) => {
        this.errorHandler.logComponentError(error);
        this.isLoading = false;
      },
    });
  }

  navigateToOnboarding(): void {
    this.navigateToMyRequests('onboarding');
  }

  navigateToMyRequests(cardType: CardType = 'header'): void {
    // this.assetMgmtService.setSelectedCard(cardType);
    localStorage.setItem('selectedCard', cardType);
    this.router.navigate(['upcoming-onboarding'], {
      relativeTo: this.route,
      state: { selectedMonth: this.selectedMonthValue },
    });
  }

  onMonthSelect(event: any): void {
    this.selectedMonthLabel = event;
    if (!event) return;

    this.selectedMonthValue = event;

    // Parse month and year from the value string
    const [monthStr, yearStr] = event.split('-');
    const monthIndex = Number(monthStr) - 1;
    const year = Number(yearStr);
    const startOfMonth = new Date(year, monthIndex, 1);
    const endOfMonth = new Date(year, monthIndex + 1, 0);
    this.loadOnboardingData(
      formatSingleDate(startOfMonth, yearDateFormat.date),
      formatSingleDate(endOfMonth, yearDateFormat.date),
    );
  }
}
